import { render, staticRenderFns } from "./StreamViewOverlay.vue?vue&type=template&id=024c7303&scoped=true&"
import script from "./StreamViewOverlay.vue?vue&type=script&lang=ts&"
export * from "./StreamViewOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./StreamViewOverlay.vue?vue&type=style&index=0&id=024c7303&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024c7303",
  null
  
)

export default component.exports